import { current } from '@reduxjs/toolkit';
import { cloneDeep } from 'lodash';

import {
    ClearMultiSelectGridParams,
    UpdateGridCellsAndCountersParams
} from './multi-select-helpers.types';
import { resetGridCells } from '@containers/activity-router/routes/helpers/grid/cells/grid-cells-helpers';
import {
    resetGridCellCounters
} from '@containers/activity-router/routes/helpers/grid/counters/grid-cell-counters/grid-cell-counters';
import { getEmptyAssignmentsSelected } from '@containers/activity-router/routes/helpers/slice/slice-defaults';
import { GridCount } from '@containers/activity-router/routes/helpers/slice/slice.types';

const {
    studentCount,
    topicCount,
    topicActivityCount,
    activityCount
} = GridCount;

export function updateMultiSelectGridCellsAndCounters ({
    gridCells,
    gridCounters,
    studentId,
    topicId,
    activityId
}: UpdateGridCellsAndCountersParams) {
    const isCurrentlySelected = gridCells[studentId][topicId][activityId].isSelected;

    gridCells[studentId][topicId][activityId].isSelected = true;

    if (!isCurrentlySelected) {
        gridCounters[studentCount][studentId].selectedActivities += 1;
        gridCounters[topicCount][topicId].selectedActivities += 1;
        gridCounters[topicActivityCount][studentId][topicId].selectedActivities += 1;
        gridCounters[activityCount][topicId][activityId].selectedActivities = [
            ...gridCounters[activityCount][topicId][activityId].selectedActivities,
            studentId
        ];
    }
}

export function getMultiSelectDraftCopy<TDraft> (draft: TDraft): TDraft {
    return cloneDeep(current(draft));
}

export function clearMultiSelectGrid ({
    gridCells,
    gridCounters
}: ClearMultiSelectGridParams) {
    return {
        gridCells: resetGridCells({
            gridCells,
            isSelected: false
        }),
        gridCounters: resetGridCellCounters({ counters: gridCounters }),
        selectedAssignments: getEmptyAssignmentsSelected()
    };
}
